import { Locale, type LocalizedString } from "../Locale.js";

export const gdprPathMap = {
	[Locale.cs]: "bezpecnost-a-ochrana-osobnich-udaju" as const,
} satisfies LocalizedString;
